export const MessageConstants = {
    apiErrorMesage:
        'An error has occurred, logged automatically for resolution. Please try again or contact Customer.Service@EnterpriseWireless.org or 1-800-482-8282 for assistance.',
} as const;
